export const MAX_IMAGE_UPLOAD_BYTES = 100 * 1024;
export const IMAGE_UPLOAD_SIZE_ERROR = "Image must be 100 KB or smaller.";

export function imageExceedsUploadLimit(file) {
  return Boolean(file && file.size > MAX_IMAGE_UPLOAD_BYTES);
}
